import { Component, input, InputSignal } from '@angular/core';
import { LoaderSize, LoaderSizeEnum } from './section-loader.types';

@Component({
  selector: 'app-section-loader',
  imports: [],
  templateUrl: './section-loader.component.html',
  styleUrl: './section-loader.component.scss'
})
export class SectionLoaderComponent {

  message: InputSignal<string> = input('loading...');
  loaderSize: InputSignal<LoaderSize> = input<LoaderSize>(LoaderSizeEnum.LG);
}
